var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9977 5.25L11.9994 5.25C13.1107 5.25 14.2649 5.52554 15.1657 6.12593C16.0887 6.74112 16.75 7.70898 16.75 9C16.75 9.9415 16.5518 10.774 16.0094 11.4981C15.4804 12.2042 14.6832 12.7264 13.6487 13.1779C13.0919 13.421 12.7494 13.9213 12.7494 14.4416V15C12.7494 15.4142 12.4136 15.75 11.9994 15.75C11.5852 15.75 11.2494 15.4142 11.2494 15V14.4416C11.2494 13.2401 12.0275 12.2489 13.0487 11.8032C13.9737 11.3994 14.5022 11.0081 14.8089 10.5987C15.1023 10.2071 15.25 9.72204 15.25 9C15.25 8.29103 14.9111 7.75889 14.3337 7.37408C13.7344 6.97459 12.8887 6.75014 12.0003 6.75C11.1103 6.75217 10.2644 6.97684 9.6653 7.37591C9.08847 7.76014 8.75001 8.29107 8.75001 9C8.75001 9.41422 8.41422 9.75 8.00001 9.75C7.58579 9.75 7.25001 9.41422 7.25001 9C7.25001 7.70893 7.911 6.74215 8.83375 6.12751C9.734 5.52785 10.8875 5.25253 11.9977 5.25Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/QuestionCircle.6c12a8661d62ec512e549d5d87641101.svg";
export { ForwardRef as ReactComponent };